'use client';

import { PagePrizeWheelSchema } from '@/sanity/pages/PagePrizeWheelTemplate';

import DesignScaleLock from '../global/DesignScaleLock';
import Footer from '../global/partials/Footer';
import HeaderV2 from '../global/partials/HeaderV2';
import ScrollingBanner from '../pageComponents/global/ScrollingBanner';
import FaqSection from '../pageComponents/global/sections/FaqSection';
import GuaranteedPrizesSection from '../pageComponents/prize-wheel/GuaranteedPrizesSection';
import PrizeWheelHeroSection from '../pageComponents/prize-wheel/PrizeWheelHeroSection';
import PrizeWheelStepsSection from '../pageComponents/prize-wheel/PrizeWheelStepsSection';

export default function PagePrizeWheelJSX({
  data,
}: {
  data: PagePrizeWheelSchema;
}) {
  return (
    <main className="flex flex-col items-center">
      <DesignScaleLock />

      {data?.settings?.header && (
        <HeaderV2
          data={data.settings.header}
          headerStyle="light"
          headerType="main"
          language={data.settings?.language}
        />
      )}

      <PrizeWheelHeroSection data={data} />
      <PrizeWheelStepsSection data={data} />
      <GuaranteedPrizesSection data={data} />

      {(data.faqTitle || !!data.faqItems?.length) && (
        <FaqSection
          data={data}
          defaultOpenFirst
          className="max-lg:pt-[8rem] lg:pt-[15rem] [&>div]:gap-[3rem] [&_.richtext]:max-w-none max-lg:[&_.richtext_h2]:!text-[4.5rem] max-lg:[&_.richtext_h2]:!tracking-[-0.225rem] lg:[&_.richtext_h2]:!text-[6rem] lg:[&_.richtext_h2]:!tracking-[-0.3rem] [&_button[data-state=open]]:pb-[1.25rem] [&_[data-state=open]_.richtext]:gap-[3.5rem] [&_.richtext_p]:[text-wrap:wrap]"
        />
      )}

      <ScrollingBanner
        words={data.scrollingWords?.words}
        wordsI18n={data.scrollingWords?.wordsI18n}
      />

      {data?.settings?.footer && (
        <Footer data={data.settings?.footer} finalCta={data} language={data?.settings?.language} />
      )}
    </main>
  );
}
